import React from 'react'
import "./Gallery.css"
const Gallery = () => {
  return (
    <div>
      Gallery 
    </div>
  )
}

export default Gallery
